'use strict';
(function BEUTE() {
 var state = {
 cartCount: 0,
 cartTotal: 0,
 cartItems: [],
 wishlist: new Set(),
 freeShipThreshold: 5000 
 };
 var $ = function(sel, ctx) { return (ctx || document).querySelector(sel); };
 var $$ = function(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };
 function formatMoney(cents) {
 return '€\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
 }
 function debounce(fn, ms) {
 var t;
 return function() {
 clearTimeout(t);
 t = setTimeout(fn, ms);
 };
 }
 var raf = window.requestAnimationFrame.bind(window);
 function initLoader() {
 var loader = $('#loader');
 if (!loader) return;
 var fill = loader.querySelector('.loader-fill');
 if (!fill) { setTimeout(function() { loader.classList.add('out'); }, 400); return; }
 fill.addEventListener('animationend', function() {
 setTimeout(function() { loader.classList.add('out'); }, 280);
 });
 setTimeout(function() { loader.classList.add('out'); }, 800);
 }
 function initCursor() {
 var dot = $('#cursor-dot');
 var ring = $('#cursor-ring');
 if (!dot || !ring) return;
 if (window.matchMedia('(pointer: coarse)').matches) return;
 document.addEventListener('mousemove', function(e) {
 dot.style.left = e.clientX + 'px';
 dot.style.top = e.clientY + 'px';
 ring.style.left = e.clientX + 'px';
 ring.style.top = e.clientY + 'px';
 }, { passive: true });
 document.addEventListener('mousedown', function() { ring.classList.add('pressing'); });
 document.addEventListener('mouseup', function() { ring.classList.remove('pressing'); });
 function addHover(el) {
 el.addEventListener('mouseenter', function() { ring.classList.add('hovered'); });
 el.addEventListener('mouseleave', function() { ring.classList.remove('hovered'); });
 }
 $$('a, button, [role="button"], .pcard, .drop-item, .brand-logo, .quality-chip').forEach(addHover);
 window.__beuteCursorRefresh = function() {
 $$('a, button, [role="button"]').forEach(addHover);
 };
 }
 function initHeader() {
 var wrap = document.getElementById('header-wrap');
 if (!wrap) return;
 var ticking = false;
 var lastY = window.scrollY;
 var state = 'visible'; 
 var timer = null;
 function setWrapTransform(px) {
 wrap.style.transform = 'translateY(-' + px + 'px)';
 }
 window.addEventListener('scroll', function() {
 if (ticking) return;
 window.requestAnimationFrame(function() {
 var y = window.scrollY;
 var goingDown = y > lastY;
 var barH = 36;
 var headerH = 68;
 if (goingDown) {
 if (state === 'visible' && y > 10) {
 state = 'bar-hidden';
 setWrapTransform(barH);
 clearTimeout(timer);
 timer = setTimeout(function() {
 if (state === 'bar-hidden') {
 state = 'all-hidden';
 setWrapTransform(barH + headerH);
 }
 }, 250);
 }
 } else {
 if (state === 'all-hidden' || state === 'bar-hidden') {
 clearTimeout(timer);
 state = 'visible';
 setWrapTransform(0);
 }
 }
 lastY = y;
 ticking = false;
 });
 ticking = true;
 }, { passive: true });
 }
 function initMobileNav() {
 var nav = $('#mobile-nav');
 var overlay = $('#overlay');
 var ham = $('.hamburger');
 var closeBtn = nav && nav.querySelector('.mobile-nav-close');
 function open() {
 nav && nav.classList.add('open');
 ham && ham.classList.add('open');
 overlay && overlay.classList.add('show');
 document.body.style.overflow = 'hidden';
 }
 function close() {
 nav && nav.classList.remove('open');
 ham && ham.classList.remove('open');
 overlay && overlay.classList.remove('show');
 document.body.style.overflow = '';
 closeCartDrawer();
 }
 ham && ham.addEventListener('click', function() {
 nav && nav.classList.contains('open') ? close() : open();
 });
 closeBtn && closeBtn.addEventListener('click', close);
 overlay && overlay.addEventListener('click', close);
 document.addEventListener('keydown', function(e) {
 if (e.key === 'Escape') close();
 });
 window.__beuteCloseNav = close;
 }
 function openCartDrawer() {
 var drawer = $('#cart-drawer');
 var overlay = $('#overlay');
 drawer && drawer.classList.add('open');
 overlay && overlay.classList.add('show');
 document.body.style.overflow = 'hidden';
 renderCart();
 }
 function closeCartDrawer() {
 var drawer = $('#cart-drawer');
 if (!drawer) return;
 drawer.classList.remove('open');
 var nav = $('#mobile-nav');
 if (!nav || !nav.classList.contains('open')) {
 var overlay = $('#overlay');
 overlay && overlay.classList.remove('show');
 document.body.style.overflow = '';
 }
 }
 function updateCartBadge() {
 $$('.cart-badge').forEach(function(b) {
 b.textContent = state.cartCount;
 b.classList.add('pop');
 setTimeout(function() { b.classList.remove('pop'); }, 300);
 });
 }
 function renderCart() {
 var itemsEl = $('#cart-items');
 var totalEl = $('#cart-total-price');
 var fillEl = $('#shipping-fill');
 var shipText = $('#shipping-text');
 if (!itemsEl) return;
 if (state.cartItems.length === 0) {
 itemsEl.innerHTML = `
 <div class="cart-empty">
 <svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24">
 <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
 <line x1="3" y1="6" x2="21" y2="6"/>
 <path d="M16 10a4 4 0 0 1-8 0"/>
 </svg>
 <p>Dein Warenkorb ist leer</p>
 <a href="collection.html" class="btn btn-outline" style="margin-top:8px;">Jetzt shoppen</a>
 </div>`;
 return;
 }
 var html = state.cartItems.map(function(item) {
 return `
 <div class="cart-item" data-id="${item.id}">
 <div class="cart-item__img" style="background:var(--c-surface);display:flex;align-items:center;justify-content:center;">
 <svg width="28" height="28" fill="none" stroke="rgba(201,168,76,.2)" stroke-width="1" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
 </div>
 <div>
 <p class="cart-item__name">${item.name}</p>
 <p class="cart-item__variant">${item.variant}</p>
 <div class="cart-item__qty">
 <button class="cart-item__qty-btn" data-action="minus" data-id="${item.id}" aria-label="Weniger">−</button>
 <span class="cart-item__qty-num">${item.qty}</span>
 <button class="cart-item__qty-btn" data-action="plus" data-id="${item.id}" aria-label="Mehr">+</button>
 </div>
 <button class="cart-item__remove" data-id="${item.id}">Entfernen</button>
 </div>
 <span class="cart-item__price">${formatMoney(item.price * item.qty * 100)}</span>
 </div>`;
 }).join('');
 itemsEl.innerHTML = html;
 $$('.cart-item__qty-btn').forEach(function(btn) {
 btn.addEventListener('click', function() {
 var id = parseInt(btn.dataset.id, 10);
 var action = btn.dataset.action;
 var item = state.cartItems.find(function(i) { return i.id === id; });
 if (!item) return;
 if (action === 'plus') item.qty++;
 else if (action === 'minus') item.qty = Math.max(1, item.qty - 1);
 state.cartTotal = state.cartItems.reduce(function(a, i) { return a + i.price * i.qty; }, 0);
 state.cartCount = state.cartItems.reduce(function(a, i) { return a + i.qty; }, 0);
 renderCart();
 updateCartBadge();
 });
 });
 $$('.cart-item__remove').forEach(function(btn) {
 btn.addEventListener('click', function() {
 var id = parseInt(btn.dataset.id, 10);
 state.cartItems = state.cartItems.filter(function(i) { return i.id !== id; });
 state.cartCount = state.cartItems.reduce(function(a, i) { return a + i.qty; }, 0);
 state.cartTotal = state.cartItems.reduce(function(a, i) { return a + i.price * i.qty; }, 0);
 renderCart();
 updateCartBadge();
 showToast('Artikel entfernt');
 });
 });
 if (totalEl) totalEl.textContent = formatMoney(state.cartTotal * 100);
 var pct = Math.min(100, Math.round((state.cartTotal * 100) / state.freeShipThreshold * 100));
 if (fillEl) fillEl.style.width = pct + '%';
 if (shipText) {
 var remaining = ((state.freeShipThreshold - state.cartTotal * 100) / 100).toFixed(2).replace('.', ',');
 shipText.innerHTML = state.cartTotal * 100 >= state.freeShipThreshold
 ? '<strong>✓ Kostenloser Versand inklusive!</strong>'
 : 'Noch <strong>€ ' + remaining + '</strong> bis zum kostenlosen Versand';
 }
 }
 function initCart() {
 $$('[data-cart-open]').forEach(function(btn) {
 btn.addEventListener('click', openCartDrawer);
 });
 var closeBtn = $('.cart-close');
 closeBtn && closeBtn.addEventListener('click', closeCartDrawer);
 var contBtn = $('.cart-continue');
 contBtn && contBtn.addEventListener('click', closeCartDrawer);
 updateCartBadge();
 renderCart();
 }
 window.addToCart = function(name, variant, price) {
 var existing = state.cartItems.find(function(i) { return i.name === name && i.variant === variant; });
 if (existing) {
 existing.qty++;
 } else {
 state.cartItems.push({
 id: Date.now(),
 name: name,
 variant: variant || 'Standard',
 price: price,
 qty: 1
 });
 }
 state.cartCount = state.cartItems.reduce(function(a, i) { return a + i.qty; }, 0);
 state.cartTotal = state.cartItems.reduce(function(a, i) { return a + i.price * i.qty; }, 0);
 updateCartBadge();
 openCartDrawer();
 showToast('✓ ' + name + ' hinzugefügt');
 };
 function initReveal() {
 if (!('IntersectionObserver' in window)) {
 $$('.reveal, .reveal-x, .reveal-xr, .stagger').forEach(function(el) {
 el.classList.add('visible');
 });
 return;
 }
 var obs = new IntersectionObserver(function(entries) {
 entries.forEach(function(entry) {
 if (entry.isIntersecting) {
 entry.target.classList.add('visible');
 obs.unobserve(entry.target);
 }
 });
 }, { threshold: 0.09, rootMargin: '0px 0px -44px 0px' });
 $$('.reveal, .reveal-x, .reveal-xr, .stagger').forEach(function(el) {
 obs.observe(el);
 });
 }
 function initClock() {
 var handH = $('#hand-hour');
 var handM = $('#hand-minute');
 var handS = $('#hand-second');
 var markers = $('#clock-markers');
 if (!handH) return;
 if (markers) {
 var frag = document.createDocumentFragment();
 for (var i = 0; i < 60; i++) {
 var el = document.createElement('div');
 var isMaj = i % 5 === 0;
 var angle = i * 6;
 el.className = 'clock-marker ' + (isMaj ? 'major' : 'minor');
 el.style.cssText =
 'position:absolute;' +
 'top:50%;left:50%;' +
 'width:' + (isMaj ? '2px' : '1px') + ';' +
 'height:' + (isMaj ? '14px' : '8px') + ';' +
 'margin-left:' + (isMaj ? '-1px' : '-0.5px') + ';' +
 'margin-top:-50%;' +
 'transform-origin:0 100%;' + 
 'transform:rotate(' + angle + 'deg) translateY(-195%);' +
 'background:rgba(201,168,76,' + (isMaj ? '0.55' : '0.18') + ');' +
 (isMaj ? 'box-shadow:0 0 6px 1px rgba(201,168,76,0.3);' : '');
 frag.appendChild(el);
 }
 markers.appendChild(frag);
 }
 var now = new Date();
 var h = now.getHours() % 12;
 var m = now.getMinutes();
 var s = now.getSeconds();
 var ms = now.getMilliseconds();
 var sDeg = (s + ms / 1000) * 6;
 var mDeg = (m + s / 60) * 6;
 var hDeg = (h + m / 60) * 30;
 var root = document.documentElement;
 root.style.setProperty('--clock-h', hDeg + 'deg');
 root.style.setProperty('--clock-m', mDeg + 'deg');
 root.style.setProperty('--clock-s', sDeg + 'deg');
 handH.style.transform = 'rotate(' + hDeg + 'deg)';
 handM.style.transform = 'rotate(' + mDeg + 'deg)';
 handS.style.transform = 'rotate(' + sDeg + 'deg)';
 raf(function() {
 raf(function() {
 handH.style.animation = 'clockH 43200s linear infinite';
 handM.style.animation = 'clockM 3600s linear infinite';
 handS.style.animation = 'clockS 60s linear infinite';
 });
 });
 }
 function initCountdown() {
 $$('[data-countdown]').forEach(function(el) {
 var seconds = parseInt(el.dataset.countdown, 10);
 var key = 'bs_cd_' + (el.dataset.id || Math.random());
 var stored = sessionStorage.getItem(key);
 var end;
 if (stored) {
 end = parseInt(stored, 10);
 } else {
 end = Date.now() + seconds * 1000;
 sessionStorage.setItem(key, end);
 }
 var hEl = el.querySelector('[data-unit="h"]');
 var mEl = el.querySelector('[data-unit="m"]');
 var sEl = el.querySelector('[data-unit="s"]');
 function tick() {
 var diff = end - Date.now();
 if (diff <= 0) {
 el.innerHTML = '<span style="font-family:var(--f-mono);font-size:.7rem;color:#E53935;letter-spacing:.15em;">ANGEBOT ABGELAUFEN</span>';
 return;
 }
 var h = Math.floor(diff / 3600000);
 var m = Math.floor((diff % 3600000) / 60000);
 var s = Math.floor((diff % 60000) / 1000);
 if (hEl) { hEl.textContent = String(h).padStart(2, '0'); }
 if (mEl) { mEl.textContent = String(m).padStart(2, '0'); }
 if (sEl) {
 var prev = sEl.textContent;
 sEl.textContent = String(s).padStart(2, '0');
 if (prev !== sEl.textContent) {
 sEl.classList.add('tick');
 setTimeout(function() { sEl.classList.remove('tick'); }, 200);
 }
 }
 setTimeout(tick, 1000);
 }
 tick();
 });
 }
 function initLiveCounter() {
 $$('[data-live-count]').forEach(function(el) {
 var base = parseInt(el.dataset.base || '14', 10);
 var range = parseInt(el.dataset.variance || '5', 10);
 var current = base;
 function update() {
 var delta = Math.floor(Math.random() * 3) - 1; 
 current = Math.max(3, Math.min(50, current + delta));
 el.textContent = current;
 setTimeout(update, 7000 + Math.random() * 10000);
 }
 update();
 });
 }
 function showToast(msg, dur) {
 var el = $('.toast');
 if (!el) {
 el = document.createElement('div');
 el.className = 'toast';
 document.body.appendChild(el);
 }
 el.textContent = msg;
 el.classList.add('show');
 clearTimeout(el._timer);
 el._timer = setTimeout(function() { el.classList.remove('show'); }, dur || 3000);
 }
 window.showToast = showToast;
 function initWishlist() {
 document.addEventListener('click', function(e) {
 var btn = e.target.closest('.pcard__wish, .wish-btn');
 if (!btn) return;
 var id = btn.dataset.id || btn.closest('[data-product-id]')?.dataset.productId || 'x';
 var active = state.wishlist.has(id);
 if (active) {
 state.wishlist.delete(id);
 btn.classList.remove('active');
 showToast('Von Wunschliste entfernt');
 } else {
 state.wishlist.add(id);
 btn.classList.add('active');
 showToast('♥ Zur Wunschliste hinzugefügt');
 }
 });
 }
 function initScrollTop() {
 var btn = $('#scroll-top');
 var ticking = false;
 if (!btn) return;
 window.addEventListener('scroll', function() {
 if (ticking) return;
 raf(function() {
 btn.classList.toggle('show', window.scrollY > 420);
 ticking = false;
 });
 ticking = true;
 }, { passive: true });
 btn.addEventListener('click', function() {
 window.scrollTo({ top: 0, behavior: 'smooth' });
 });
 }
 function initParallax() {
 var els = $$('[data-parallax]');
 if (!els.length) return;
 var ticking = false;
 window.addEventListener('scroll', function() {
 if (ticking) return;
 raf(function() {
 var sy = window.scrollY;
 els.forEach(function(el) {
 var speed = parseFloat(el.dataset.parallax || '0.3');
 el.style.transform = 'translateY(' + sy * speed + 'px)';
 });
 ticking = false;
 });
 ticking = true;
 }, { passive: true });
 }
 function initAnchors() {
 document.addEventListener('click', function(e) {
 var a = e.target.closest('a[href^="#"]');
 if (!a) return;
 var target = document.querySelector(a.getAttribute('href'));
 if (!target) return;
 e.preventDefault();
 var top = target.getBoundingClientRect().top + window.scrollY - 80;
 window.scrollTo({ top: top, behavior: 'smooth' });
 });
 }
 function initMarquee() {
 $$('.marquee-inner').forEach(function(el) {
 if (el.children.length === 0) return;
 if (el.dataset.duped) return;
 var clone = el.cloneNode(true);
 el.parentNode.appendChild(clone);
 el.dataset.duped = '1';
 });
 }
 function initVariants() {
 document.addEventListener('click', function(e) {
 var btn = e.target.closest('.variant-btn');
 if (!btn || btn.disabled) return;
 var group = btn.closest('.variant-group');
 if (group) {
 group.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
 }
 btn.classList.add('active');
 var price = btn.dataset.price;
 if (price) {
 var priceEl = document.querySelector('.pdp-price-current');
 if (priceEl) priceEl.textContent = formatMoney(parseInt(price, 10));
 }
 var stickyPrice = $('.sticky-bar__price');
 if (stickyPrice && price) stickyPrice.textContent = formatMoney(parseInt(price, 10));
 });
 }
 function initStickyBar() {
 var bar = $('#sticky-atc-bar');
 var mainBtn= $('#main-atc-btn');
 if (!bar || !mainBtn) return;
 var obs = new IntersectionObserver(function(entries) {
 entries.forEach(function(entry) {
 bar.classList.toggle('show', !entry.isIntersecting);
 });
 }, { threshold: 0.1 });
 obs.observe(mainBtn);
 var stickyBtn = bar.querySelector('.sticky-bar__btn');
 stickyBtn && stickyBtn.addEventListener('click', function() {
 mainBtn.click();
 });
 }
 function initGallery() {
 var thumbs = $$('.gallery-thumb');
 var mainImg = $('#gallery-main-img');
 if (!thumbs.length || !mainImg) return;
 thumbs.forEach(function(thumb) {
 thumb.addEventListener('click', function() {
 thumbs.forEach(function(t) { t.classList.remove('active'); });
 thumb.classList.add('active');
 mainImg.style.opacity = '0';
 setTimeout(function() {
 mainImg.src = thumb.querySelector('img')?.src || mainImg.src;
 mainImg.style.opacity = '1';
 }, 180);
 mainImg.style.transition = 'opacity 0.18s';
 });
 });
 }
 function initTabs() {
 document.addEventListener('click', function(e) {
 var tab = e.target.closest('[data-tab]');
 if (!tab) return;
 var panelId = tab.dataset.tab;
 var container = tab.closest('[data-tabs]') || document;
 container.querySelectorAll('[data-tab]').forEach(function(t) { t.classList.remove('active'); });
 container.querySelectorAll('[data-panel]').forEach(function(p) { p.classList.remove('active'); });
 tab.classList.add('active');
 var panel = container.querySelector('[data-panel="' + panelId + '"]');
 if (panel) panel.classList.add('active');
 });
 }
 var exitFired = false;
 function initExitIntent() {
 document.addEventListener('mouseleave', function(e) {
 if (e.clientY > 0 || exitFired) return;
 exitFired = true;
 showToast('Warte! Schau dir noch unsere neuen Arrivals an 👀', 5000);
 });
 }
 function boot() {
 initLoader();
 initCursor();
 initHeader();
 initMobileNav();
 initCart();
 initReveal();
 initClock();
 initCountdown();
 initLiveCounter();
 initWishlist();
 initScrollTop();
 initParallax();
 initAnchors();
 initMarquee();
 initVariants();
 initStickyBar();
 initGallery();
 initTabs();
 initExitIntent();
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', boot);
 } else {
 boot();
 }
 window.BEUTE = {
 addToCart: window.addToCart,
 showToast: showToast,
 openCart: openCartDrawer,
 closeCart: closeCartDrawer,
 formatMoney: formatMoney
 };
})();